import { ReviewQueryResult } from '@danone-global/ct/interfaces'
import React from 'react'

import Review from './review'
import { useReviewRating } from './reviews-list.hooks'

export interface Props {
  sku: string
  productName: string
  reviews: ReviewQueryResult
  refetch: () => void
  withAnalytics: boolean
  provideStructuredData?: boolean
  reviewLayout?: string
  starClasses?: string
  starActiveClasses?: string
}

export const ReviewsList: React.FC<Props> = ({
  reviews,
  productName,
  refetch,
  sku,
  withAnalytics,
  provideStructuredData,
  reviewLayout = undefined,
  starClasses = '',
  starActiveClasses = '',
}) => {
  const { upvote, downVote } = useReviewRating(
    refetch,
    sku,
    productName,
    withAnalytics,
  )

  return (
    <div className="dtc-reviews">
      {reviews?.results?.map((review) => (
        <Review
          key={review.id}
          downVote={downVote}
          productName={productName}
          provideStructuredData={provideStructuredData}
          sku={sku}
          starActiveClasses={starActiveClasses}
          starClasses={starClasses}
          upvote={upvote}
          {...review}
          {...(reviewLayout && { stringComponentLayout: reviewLayout })}
        />
      ))}
    </div>
  )
}

export default ReviewsList
